import React from 'react';
import visaImg from 'images/visa.svg';
import mastercardImg from 'images/mastercard.svg';
import { CardBrandFallback } from './PaymentInfoPage.styles';

type CardBrand = string | null | undefined;

// Stripe card.brand values: 'visa' | 'mastercard' | 'amex' | 'discover'
// | 'diners' | 'jcb' | 'unionpay' | 'unknown'
const BRAND_LABELS: Record<string, string> = {
  amex: 'AMEX',
  'american express': 'AMEX',
  discover: 'DISC',
  diners: 'DINERS',
  'diners club': 'DINERS',
  jcb: 'JCB',
  unionpay: 'UNION',
};

const CardBrandIcon: React.FC<{ brand: CardBrand; altLabel?: string }> = ({ brand, altLabel }) => {
  const normalized = (brand || '').toLowerCase().trim();

  if (normalized === 'visa') {
    return <img src={visaImg} alt="Visa" />;
  }
  if (normalized === 'mastercard') {
    return <img src={mastercardImg} alt="Mastercard" />;
  }

  const label = BRAND_LABELS[normalized] || (altLabel || 'CARD');
  return <CardBrandFallback aria-label={normalized || 'card'}>{label}</CardBrandFallback>;
};

export default CardBrandIcon;
